var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgFedExPickup = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3333 20.9998V6.99984C16.3333 6.381 16.0874 5.78751 15.6498 5.34992C15.2122 4.91234 14.6188 4.6665 13.9999 4.6665H4.66659C4.04775 4.6665 3.45425 4.91234 3.01667 5.34992C2.57908 5.78751 2.33325 6.381 2.33325 6.99984V19.8332C2.33325 20.1426 2.45617 20.4393 2.67496 20.6581C2.89375 20.8769 3.1905 20.9998 3.49992 20.9998H5.83325",
    stroke: "#0F4A43",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 21H10.5",
    stroke: "#0F4A43",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1666 21.0002H24.4999C24.8093 21.0002 25.1061 20.8772 25.3249 20.6585C25.5437 20.4397 25.6666 20.1429 25.6666 19.8335V15.5752C25.6661 15.3104 25.5756 15.0537 25.4099 14.8472L21.3499 9.77216C21.2408 9.63552 21.1024 9.52516 20.9449 9.44923C20.7873 9.3733 20.6148 9.33375 20.4399 9.3335H16.3333",
    stroke: "#0F4A43",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8333 23.3332C21.122 23.3332 22.1667 22.2885 22.1667 20.9998C22.1667 19.7112 21.122 18.6665 19.8333 18.6665C18.5447 18.6665 17.5 19.7112 17.5 20.9998C17.5 22.2885 18.5447 23.3332 19.8333 23.3332Z",
    stroke: "#0F4A43",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16659 23.3332C9.45525 23.3332 10.4999 22.2885 10.4999 20.9998C10.4999 19.7112 9.45525 18.6665 8.16659 18.6665C6.87792 18.6665 5.83325 19.7112 5.83325 20.9998C5.83325 22.2885 6.87792 23.3332 8.16659 23.3332Z",
    stroke: "#0F4A43",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFedExPickup, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/FedEx_Pickup.86af12f8.svg";
export { ForwardRef as ReactComponent };